















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Action, Getter, namespace } from 'vuex-class';
@Component
export default class LeftNav extends Vue {
  private isCollapse = true;
  private currentPath: string = '';
  @Prop() private navList!: any[];
  @Watch('$route', { immediate: true, deep: true })
  public onRouterChange() {
    this.currentPath = this.$route.path;
  }

  public mounted() {
    const reportRouter: string[] = [
      '/index/report/dailyStockReport/level1',
      '/index/report/dailyStockReport/level2',
      '/index/report/dailyStockReport/level3',
      '/index/report/dailyIncomeReport/level1',
      '/index/report/dailyIncomeReport/level2',
      '/index/report/dailyIncomeReport/level3',
      '/index/report/monthlyIncomeReport/level1',
      '/index/report/monthlyIncomeReport/level2',
      '/index/report/monthlyIncomeReport/level3',
      '/index/report/dailyBusinessReport/level1',
      '/index/report/dailyBusinessReport/level2',
      '/index/report/dailyBusinessReport/level3',
      '/index/report/monthlyBusinessReport/level1',
      '/index/report/monthlyBusinessReport/level2',
      '/index/report/monthlyBusinessReport/level3',
    ];
    let current = reportRouter.some((item: string) => {
      return item === this.$route.path;
    });
    if (current) {
      this.currentPath = "/index/report/summary";
    } else {
      this.currentPath = this.$route.path;
    }
  }

  public handleOpen(key: number, keyPath: string) {
    // console.log(key, keyPath);
  }
  public handleClose(key: number, keyPath: string) {
    // console.log(key, keyPath);
  }
  
  public go(path: string) {
    this.$router.push({path});
  }
}
